import React from 'react'
import './RedirectingTo.css'
import { usbc_icon } from '../../Shared/icons'

function RedirectingTo(props) {

    React.useEffect(() => {
      setTimeout(() => {
         window.location.replace(props.url);
      }, props.timeout);
    }, []);

    return (
        <>
            <div className='redirect-to-container d-flex justify-content-center'>
                <div style={{ width: '800px' }}>
                    <div>
                        <div className="icon-box">
                            <div className={'redirect-to-container-icon'}>{usbc_icon}</div>
                        </div>
                        <h4 className="header-text w-100">Redirecting to <a href={props.url}>{props.linkTitle}</a></h4>
                    </div>
                </div>
            </div>
        </>
    )
}


export default RedirectingTo